"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative min-h-[600px] w-full overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1516646/img/hero_comfortable_indoor_hvac.png)] transition-transform duration-[var(--duration-fast)] ease-out hover:scale-[1.002]">
      <div className="absolute inset-0 bg-primary/60 backdrop-blur-sm" />
      
      <div className={`relative z-10 flex min-h-[600px] flex-col items-center justify-center px-6 text-center transition-all ${isVisible ? "animate-fade-in-up" : "opacity-0"}`}>
        <h1 className="mb-4 max-w-4xl font-display text-5xl font-bold leading-tight text-foreground-primary sm:text-6xl lg:text-7xl">
          Expert HVAC Solutions for Pittsburgh
        </h1>
        
        <p className="mb-8 max-w-2xl text-lg text-foreground-primary/90 sm:text-xl">
          Impeccable craftsmanship and customer satisfaction for residential and commercial heating, ventilation, and air conditioning systems.
        </p>
        
        <Link to="/ContactPage">
          <Button size="lg" className="shadow-strong hover:shadow-strong">
            Schedule Service Today
          </Button>
        </Link>
      </div>
    </section>;
}